import { useEffect } from "react";
import { canonicalEventUrl } from "@/lib/eventUrl";
import { fileUrl } from "@/lib/api";

function setTag(selector, create, attr, value) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    el.dataset.eventSeo = "1";
    document.head.appendChild(el);
  }
  el.setAttribute(attr, value);
}

const meta = (key, prop) => () => {
  const m = document.createElement("meta");
  m.setAttribute(prop ? "property" : "name", key);
  return m;
};

export function useEventSeo(event) {
  useEffect(() => {
    if (!event) return undefined;
    const prevTitle = document.title;
    const url = canonicalEventUrl(event);
    const desc = (event.description || `You're invited to ${event.title}. RSVP online.`).slice(0, 200);
    document.title = `${event.title} | Godinga Events`;
    setTag('link[rel="canonical"]', () => Object.assign(document.createElement("link"), { rel: "canonical" }), "href", url);
    setTag('meta[name="description"]', meta("description"), "content", desc);
    setTag('meta[property="og:title"]', meta("og:title", true), "content", event.title);
    setTag('meta[property="og:description"]', meta("og:description", true), "content", desc);
    setTag('meta[property="og:url"]', meta("og:url", true), "content", url);
    if (event.cover_image) setTag('meta[property="og:image"]', meta("og:image", true), "content", fileUrl(event.cover_image));
    return () => {
      document.title = prevTitle;
      document.head.querySelectorAll("[data-event-seo]").forEach((el) => el.remove());
    };
  }, [event]);
}
